<template>
  <div class="m-t-30">
    <!-- Container-fluid starts-->
    <b-overlay :show="loading" rounded="sm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card shadow-none">
            <b-button v-if="prevBtn" @click="prevBtn(imageId)" class="RightSidebar_PrevBtn" variant="outline-dark"><i
                class="fa fa-chevron-left"></i></b-button>
            <b-button v-if="nextBtn" @click="nextBtn(imageId)" class="RightSidebar_NextBtn" variant="outline-dark"><i
                class="fa fa-chevron-right"></i></b-button>
            <div class="card-body">
              <div class="row">
                <div class="col-xl-12 col-md-12 my-gallery gallery pl-0">
                  <div class="blog-box blog-grid text-center product-box form-group" style="border-radius: 0px">
                    <div class="product-img" v-if="myimgSrc">
                      <img class="img-fluid top-radius-blog" :src="myimgSrc" v-if="!showCropTools" alt="" style="border: 2px solid black;"/>
                      <div  class="product-hover">
                        <ul>
                          <li @click="startEdit"><i class="fa fa-pencil"></i></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="img-container form-group" v-show="showCropTools || !myimgSrc">
                    <!-- <input class="form-control" type="file" accept="image/*" @change="setImage"
                                            ref="fileupload" /> -->
                    <b-form-file class="mb-2" @change="setImage" v-model="imageModel" accept="image/*" ref="fileupload"
                      :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')"
                      :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')"
                      :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')"
                      :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')"></b-form-file>
                    <div>
                      <vue-cropper ref="cropper" :guides="true" :view-mode="viewmode" :drag-mode="dragMode"
                        :aspectRatio="aspectRatioselected" :auto-crop-area="1" :background="true" :src="myimgSrc"
                        alt="Source Image" :ready="ready" :crop="cropImage" v-show="showCropTools"
                        :containerStyle="{  }" :movable="movable" :rotatable="rotatable"
                        :scalable="scalable" :zoomable="zoomable" :zoomOnTouch="zoomOnTouch" :zoomOnWheel="zoomOnWheel"
                        :cropBoxMovable="cropBoxMovable" :cropBoxResizable="cropBoxResizable"
                        :toggleDragModeOnDblclick="toggleDragModeOnDblclick"
                        :minCropBoxWidth="minCropBoxWidth"
                        :minCropBoxHeight="minCropBoxHeight"
                        :minCanvasWidth="minCanvasWidth"
                        :minCanvasHeight="minCanvasHeight"
                        :minContainerWidth="minContainerWidth"
                        :minContainerHeight="minContainerHeight"
                        :autoCrop="autoCrop">
                      </vue-cropper>
                    </div>
                    <div class="row img-cropper m-t-15" v-show="showCropTools && !limitCropFunction">
                      <div class="col-xl-12 col-md-12 docs-buttons">
                        <b-button-group>
                          <b-button variant="outline-primary" v-on:click="zoominImage"><span
                              class="fa fa-search-plus"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="zoomoutImage" class="br-right"><span
                              class="fa fa-search-minus"></span></b-button>
                        </b-button-group>
                        <!-- <b-button-group>
                          <b-button variant="outline-primary" v-on:click="moveImageLeft">
                            <span class="fa fa-arrow-left"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="moveImageRight">
                            <span class="fa fa-arrow-right"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="moveImageUp"
                            ><span class="fa fa-arrow-up"></span>
                          </b-button>
                          <b-button
                            variant="outline-primary"
                            v-on:click="moveImageDown"
                            class="br-right"
                            ><span class="fa fa-arrow-down"></span
                          ></b-button>
                        </b-button-group> -->
                        <b-button-group>
                          <b-button variant="outline-primary" v-on:click="rotateLeft">
                            <span class="fa fa-rotate-left"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="rotateRight" class="br-right"><span
                              class="fa fa-rotate-right"></span></b-button>
                        </b-button-group>
                        <!-- <b-button-group>
                          <b-button variant="outline-primary" v-on:click="fliphorizontal"><span
                              class="fa fa-arrows-h"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="flipvertical" class="br-right"><span
                              class="fa fa-arrows-v"></span></b-button>
                        </b-button-group>
                        <b-button-group>
                          <b-button variant="outline-primary" v-on:click="reset">
                            <span class="fa fa-refresh"></span>
                          </b-button>
                        </b-button-group>
                        <b-button-group>
                          <b-button variant="outline-primary" v-on:click="crop">
                            <span class="fa fa-check"></span>
                          </b-button>
                          <b-button variant="outline-primary" v-on:click="cancel" class="br-right"><span
                              class="fa fa-remove"></span></b-button>
                        </b-button-group> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-12 p-0">
                    <textbox :title="$t('lbl_EMPBE_PhotoName')" type="text" v-model="myimgName" v-if="needImageName">
                    </textbox>
                  </div>
                  <div v-if="!disabled" class="m-b-15">
                    <b-button variant="outline-danger" v-on:click="remove" class="f-right br-right m-l-5">{{
                      $t("lbl_EMPBE_Delete") }}</b-button>
                    <b-button class="f-right br-right" variant="outline-primary" v-on:click="confirm">{{
                      $t("Lbl_PopupForm_Submit") }}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </b-overlay>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import GIF from '../../../../src/assets/js/gif';
import { getGifWorker } from '../../../../src/assets/js/gif.worker.js';
import { GifToCanvas } from '../../../../src/assets/js/gifToCanvas.js'

export default {
  props: [
    "imageId",
    "imageSrc",
    "imageName",
    "UpdateImage",
    "DeleteImage",
    "aspectRatioselected",
    "needImageName",
    "FileName",
    "prevBtn",
    "nextBtn",
    "limitCropFunction",
    "disabled",
    "minCropBoxWidth",
    "minCropBoxHeight",
    "minCanvasWidth",
    "minCanvasHeight",
    "minContainerWidth",
    "minContainerHeight",
    "viewmode",
    "autoCrop"
  ],
  components: {
    VueCropper,
  },
  data() {
    return {
      loading: false,
      imageModel: null,
      myimgSrc: this.imageSrc,
      myimgName: this.imageName,
      myFileName: this.FileName,
      imgSrc: "",
      imageData: "",
      containerData: "",
      putData: "",
      cropImg: "",
      zoomImageScale: 1,
      hoverImage: false,
      showCropTools: false,
      uploadScr: "",
      dragMode: !this.limitCropFunction ? 'move' : 'none',
      zoomOnWheel: false,
      movable: !this.limitCropFunction,
      rotatable: !this.limitCropFunction,
      scalable: !this.limitCropFunction,
      zoomable: !this.limitCropFunction,
      zoomOnTouch: !this.limitCropFunction,
      cropBoxMovable: !this.limitCropFunction,
      cropBoxResizable: !this.limitCropFunction,
      toggleDragModeOnDblclick: !this.limitCropFunction,
      isGif: false,
      gifToCanvas: '',
      gif: '',
      myCropper: "",
      getCroppedCanvasOptions:{
        maxWidth:2500,
        maxHeight:2500,
      }
    };
  },
  mounted() { },
  watch: {
  },
  methods: {
    ready() {
      if (this.$refs.cropper) {
        this.containerData = this.$refs.cropper.getContainerData();
        this.CalZoomScale();
      }
    },
    cropImage() {
      if (this.$refs.cropper) {
        this.imageData = this.$refs.cropper.getData();
        const canvas = this.$refs.cropper.getCroppedCanvas(
          this.getCroppedCanvasOptions
        );
        // 检测是否为透明图片，如果是则应用白色背景
        this.cropImg = this.applyBackgroundToCanvas(canvas);
      }
    },
    async crop() {
      var that = this
      this.imageData = this.$refs.cropper.getData();
      const canvas = this.$refs.cropper.getCroppedCanvas(
        this.getCroppedCanvasOptions
      );
      // 检测是否为透明图片，如果是则应用白色背景
      this.cropImg = this.applyBackgroundToCanvas(canvas);
      
      if (this.isGif) {
        var gifBlob = await this.cropGifHandle();
        var gifBase64 = await this.blobToBase64(gifBlob);
        this.cropImg = gifBase64;
      }
      this.myimgSrc = this.cropImg;
      this.showCropTools = false;
    },
    // 检测图片是否透明，如果是则应用白色背景
    applyBackgroundToCanvas(canvas) {
      if (!canvas) return '';
      
      // 检查图片是否有透明通道
      const ctx = canvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      let hasTransparency = false;
      
      // 检查是否有透明像素
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
          hasTransparency = true;
          break;
        }
      }
      
      // 如果有透明通道，创建新canvas并填充白色背景
      if (hasTransparency) {
        const newCanvas = document.createElement('canvas');
        newCanvas.width = canvas.width;
        newCanvas.height = canvas.height;
        const newCtx = newCanvas.getContext('2d');
        
        // 填充白色背景
        newCtx.fillStyle = '#FFFFFF';
        newCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);
        
        // 绘制原图
        newCtx.drawImage(canvas, 0, 0);
        
        return newCanvas.toDataURL("image/webp");
      }
      
      // 没有透明通道，直接返回
      return canvas.toDataURL("image/webp");
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      
      return new Blob([u8arr], { type: mime });
    },
    //gif裁剪
    async cropGifHandle() {
      var that = this;
      return new Promise(async (resolve, reject) => {
        if (this.$refs.cropper) {
          that.loading = true;
          var dataUrl = that.$refs.cropper.cropper.url
          if(that.$refs.cropper.cropper.url.indexOf('https://') >= 0){
            dataUrl = await this.convertURLtoBase64(that.$refs.cropper.cropper.url);
          }
          const url = URL.createObjectURL(this.dataURLtoBlob(dataUrl));
          const cropBoxData = this.$refs.cropper.getCropBoxData();
          const canvasData = this.$refs.cropper.getCanvasData();
          this.gifToCanvas = new GifToCanvas(url, {
            targetOffset: {
              dx: cropBoxData.left - canvasData.left,
              dy: cropBoxData.top - canvasData.top,
              width: canvasData.width,
              height: canvasData.height,
              sWidth: cropBoxData.width,
              sHeight: cropBoxData.height,
            },
          });
          this.gif = new GIF({
            workers: 4,
            quality: 10,
            workerScript: getGifWorker(),
          });
          const addFrame = (canvas, delay) => {
            this.gif.addFrame(canvas, { copy: true, delay });
          };
          this.gifToCanvas.on("progress", (canvas, delay) => {
            addFrame(canvas, delay);
          });
          this.gifToCanvas.on("finished", (canvas, delay) => {
            addFrame(canvas, delay);
            this.gif.render();
          });
          this.gif.on("finished", (blob) => {
            console.log("finished", window.URL.createObjectURL(blob));
            that.loading = false;
            resolve(blob);
          });
          this.gifToCanvas.init();
        } else {
          reject();
        }
      });
    },
    blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    async convertURLtoBase64 (url) {
      const response = await fetch(url);
      const data = await response.blob();
      var base64string = await this.blobToBase64(data);
      return base64string;
    },
    moveImage() {
      this.$refs.cropper.move(1);
    },
    CalZoomScale() {
      var data = this.$refs.cropper.getData();
      var containerData = this.$refs.cropper.getContainerData();
      var scale = containerData.width / data.width;
      this.zoomImageScale = scale;
      this.$refs.cropper.zoomTo(this.zoomImageScale);
    },
    zoominImage() {
      this.zoomImageScale += 0.1;
      this.$refs.cropper.zoomTo(this.zoomImageScale);
    },
    zoomoutImage() {
      this.zoomImageScale -= 0.1;
      this.$refs.cropper.zoomTo(this.zoomImageScale);
    },
    zoom100() {
      this.$refs.cropper.zoomTo(1);
    },
    moveImageLeft() {
      this.$refs.cropper.move(-10, 0);
    },
    moveImageRight() {
      this.$refs.cropper.move(10, 0);
    },
    moveImageUp() {
      this.$refs.cropper.move(0, 10);
    },
    moveImageDown() {
      this.$refs.cropper.move(0, -10);
    },
    moveImageTo() {
      this.$refs.cropper.moveTo(0);
    },
    rotateLeft() {
      this.$refs.cropper.rotate(-90);
    },
    rotateRight() {
      this.$refs.cropper.rotate(90);
    },
    rotate180() {
      this.$refs.cropper.rotateTo(180);
    },
    fliphorizontal() {
      if (this.imageData.scaleX === 1) {
        this.$refs.cropper.scale(-1, 1);
      } else {
        this.$refs.cropper.scale(1, 1);
      }
    },
    flipvertical() {
      if (this.imageData.scaleY === 1) {
        this.$refs.cropper.scale(1, -1);
      } else {
        this.$refs.cropper.scale(1, 1);
      }
    },
    scaleImage() {
      this.$refs.cropper.scale(-2, -1);
    },
    clear() {
      this.$refs.cropper.clear();
    },
    cancel() {
      this.reset();
      this.showCropTools = false;
    },
    disable() {
      this.$refs.cropper.disable();
    },
    enable() {
      this.$refs.cropper.enable();
    },
    reset() {
      this.$refs.cropper.reset();
    },
    destroy() {
      this.$refs.cropper.destroy();
    },
    getCroppedCanvas() {
      this.$refs.getCroppedCanvasModal.show();
    },
    getCroppedCanvas4096() {
      this.$refs.getCroppedCanvas4096.show();
    },
    getCroppedCanvas16090() {
      this.$refs.getCroppedCanvas16090.show();
    },
    getCroppedCanvas320180() {
      this.$refs.getCroppedCanvas320180.show();
    },
    getCropperdata() {
      var data = this.$refs.cropper.getData();
      this.putData =
        '{"x":' +
        data.x +
        ',"y":' +
        data.y +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"rotate":' +
        data.rotate +
        ',"scaleX":' +
        data.scaleX +
        ',"scaleY":' +
        data.scaleY +
        "}";
    },
    getContainerdata() {
      var data = this.$refs.cropper.getContainerData();
      this.putData = '{"width":' + data.width + ',"height":' + data.height + "}";
    },
    getImagedata() {
      var data = this.$refs.cropper.getImageData();
      this.putData =
        '{"naturalWidth":' +
        data.naturalWidth +
        ',"naturalHeight":' +
        data.naturalHeight +
        ',"aspectRatio":' +
        data.aspectRatio +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"left":' +
        data.left +
        ',"top":' +
        data.top +
        "}";
    },
    getCanvasData() {
      var data = this.$refs.cropper.getCanvasData();
      this.putData =
        '{"left":' +
        data.left +
        ',"top":' +
        data.top +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"naturalWidth":' +
        data.naturalWidth +
        ',"naturalHeight":' +
        data.naturalHeight +
        "}";
    },
    getCropBoxData() {
      var data = this.$refs.cropper.getCropBoxData();
      this.putData =
        '{"left":' +
        data.left +
        ',"top":' +
        data.top +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        "}";
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert(this.$t("lbl_EMPBE_PleaseSelectImage"));
        return;
      }
      if (file.type.indexOf("gif") > 0) {
        this.isGif = true;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$nextTick(() => {
          this.imageModel = null;
        });
        this.$swal({
          text: this.$t("lbl_EMPBE_ImageMaxFileSizeReached"),
          showCancelButton: false,
        });
        return;
      } //5MB
      this.myFileName = file.name;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.showCropTools = true;
          this.$refs.cropper.replace(event.target.result);
          this.$refs.fileupload.value = null;
        };
        reader.readAsDataURL(file);
      } else {
        alert(this.$t("lbl_EMPBE_FileReaderNotSupport"));
      }
    },
    startEdit() {
      this.showCropTools = true;
      this.$refs.cropper.replace(this.myimgSrc, false);
      if (this.myimgSrc != '') {
        //Check if gif
        var extension = (/[.]/.exec(this.myimgSrc)) ? /[^.]+$/.exec(this.myimgSrc) : [""];
        if (extension[0] == 'gif') {
          this.isGif = true;
        } else if(this.checkBase64IsGif()){
          this.isGif = true;          
        } else {
          this.isGif = false;
        }
      }
    },
    checkBase64IsGif() {
      try {
        if(this.myimgSrc.substring("data:image/".length, this.myimgSrc.indexOf(";base64")) == 'gif'){
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error(error);
        return false
      }
    },
    async confirm() {
      if (this.showCropTools) {
        await this.crop();
      }
      if (this.myimgName == undefined) this.myimgName = "";
      this.UpdateImage(this.imageId, this.myimgSrc, this.myimgName, this.myFileName);
      if (this.imageId == 0) {
        this.myimgSrc = "";
        this.myimgName = "";
        this.myFileName = "";
      }
      this.imageModel = null;
    },
    remove() {
      this.imageModel = null;
      if (this.imageId != 0) {
        this.DeleteImage(this.imageId);
      } else {
        this.cancel();
      }
    },
  },
};
</script>
